import { render, staticRenderFns } from "./GlobalSetting.vue?vue&type=template&id=0a4ca3bd&scoped=true&"
import script from "./GlobalSetting.vue?vue&type=script&lang=ts&"
export * from "./GlobalSetting.vue?vue&type=script&lang=ts&"
import style0 from "./GlobalSetting.vue?vue&type=style&index=0&id=0a4ca3bd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a4ca3bd",
  null
  
)

export default component.exports